import React, { useContext } from "react";
import { developOptions } from "../../../config/developOptions";
import DevelopOptionsPanel from "../../shared/components/DevelopOptionsPanel";
import { Payment } from "../../modules/payment/Payment/Payment";
import { useParams } from "react-router";
import ResponsiveLayout from "../../shared/components/ResponsiveLayout";
import { usePaymentView } from "./hooks/usePaymentView";
import LogoContainer from "../../shared/components/LogoContainer";
import { Box } from "@material-ui/core";
import FlowLoadingWindowManager from "../../shared/sharedKernel/FlowLoadingWindowManager";
import { ConfigContext } from "../../../contexts/ConfigContext";
import { HeaderButtons } from "../../shared/components/HeaderButtons";

export const PaymentView = ({ forceDevOptionsPanel }) => {
  const { paymentPlanLineId } = useParams();
  usePaymentView();
  const {
    state: { language },
  } = useContext(ConfigContext);

  if (!language) return <></>;
  return (
    <div style={{ height: "100%" }}>
      {(developOptions.SHOW_DEV_OPTIONS || forceDevOptionsPanel) && (
        <DevelopOptionsPanel />
      )}
      <ResponsiveLayout>
        <FlowLoadingWindowManager />
        <LogoContainer appStarted={true} />
        <Box
          height={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          flexGrow={1}
        >
          <HeaderButtons />
          <Payment paymentPlanLineId={paymentPlanLineId} />
        </Box>
      </ResponsiveLayout>
    </div>
  );
};
